/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Exclusive_Feature_Focus_Data_SubtitleInputs */

const en_subscription_exclusive_feature_focus_data_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Focus_Data_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Understand your focus habits and keep improving.`)
};

const ar_subscription_exclusive_feature_focus_data_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Focus_Data_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`افهم عادات تركيزك واستمر في التحسين.`)
};

const de_subscription_exclusive_feature_focus_data_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Focus_Data_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verstehen Sie Ihre Konzentrationsgewohnheiten und verbessern Sie sich weiter.`)
};

const es_subscription_exclusive_feature_focus_data_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Focus_Data_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprende tus hábitos de concentración y sigue mejorando.`)
};

const fr_subscription_exclusive_feature_focus_data_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Focus_Data_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprenez vos habitudes de concentration et progressez jour après jour.`)
};

const it_subscription_exclusive_feature_focus_data_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Focus_Data_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprendi le tue abitudini di concentrazione e continua a migliorare.`)
};

const ja_subscription_exclusive_feature_focus_data_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Focus_Data_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自分の集中の癖を理解し、改善し続ける`)
};

const ko_subscription_exclusive_feature_focus_data_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Focus_Data_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`자신의 집중 습관을 파악하고 꾸준히 개선하세요.`)
};

const pt_br_subscription_exclusive_feature_focus_data_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Focus_Data_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entenda seus hábitos de foco e continue melhorando.`)
};

const ru_subscription_exclusive_feature_focus_data_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Focus_Data_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изучите свои привычки концентрации внимания и продолжайте совершенствоваться.`)
};

const th_subscription_exclusive_feature_focus_data_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Focus_Data_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทำความเข้าใจนิสัยการโฟกัสของคุณและปรับปรุงอย่างต่อเนื่อง`)
};

const tr_subscription_exclusive_feature_focus_data_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Focus_Data_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odaklanma alışkanlıklarını anla ve onları geliştirmeye devam et.`)
};

const zh_cn_subscription_exclusive_feature_focus_data_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Focus_Data_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`了解专注习惯，持续进步`)
};

const zh_tw_subscription_exclusive_feature_focus_data_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Focus_Data_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`了解專注習慣，持續進步`)
};

/**
* | output |
* | --- |
* | "Understand your focus habits and keep improving." |
*
* @param {Subscription_Exclusive_Feature_Focus_Data_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_exclusive_feature_focus_data_subtitle = /** @type {((inputs?: Subscription_Exclusive_Feature_Focus_Data_SubtitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Exclusive_Feature_Focus_Data_SubtitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_exclusive_feature_focus_data_subtitle(inputs)
	if (locale === "ar") return ar_subscription_exclusive_feature_focus_data_subtitle(inputs)
	if (locale === "de") return de_subscription_exclusive_feature_focus_data_subtitle(inputs)
	if (locale === "es") return es_subscription_exclusive_feature_focus_data_subtitle(inputs)
	if (locale === "fr") return fr_subscription_exclusive_feature_focus_data_subtitle(inputs)
	if (locale === "it") return it_subscription_exclusive_feature_focus_data_subtitle(inputs)
	if (locale === "ja") return ja_subscription_exclusive_feature_focus_data_subtitle(inputs)
	if (locale === "ko") return ko_subscription_exclusive_feature_focus_data_subtitle(inputs)
	if (locale === "pt_br") return pt_br_subscription_exclusive_feature_focus_data_subtitle(inputs)
	if (locale === "ru") return ru_subscription_exclusive_feature_focus_data_subtitle(inputs)
	if (locale === "th") return th_subscription_exclusive_feature_focus_data_subtitle(inputs)
	if (locale === "tr") return tr_subscription_exclusive_feature_focus_data_subtitle(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_exclusive_feature_focus_data_subtitle(inputs)
	return zh_tw_subscription_exclusive_feature_focus_data_subtitle(inputs)
});